<template>

  <div class="card mb-4">  
    <div class="card-header">
      <h5 class="my-0 font-weight-normal">{{ planscope.name }}</h5>
    </div>
    <div class="card-body">
      <div class="mb-3">
        <div v-if="price">
          <div class="mb-3">
            <div class="mb-2">{{ cycleName }}</div>

            <div
              v-if="discount"
              class="badge badge-success mb-2"
              style="font-size: 1rem;"><b>{{ discount }}%</b> off</div>
            <div
              v-if="discount"
              class="text-muted"
              style="text-decoration: line-through">
              {{ $n(monthPriceFrom, {style: 'currency', currency: 'BRL'}) }}
            </div>
            <h4 class="m-0">
              {{ $n(monthPrice, {style: 'currency', currency: 'BRL'}) }}<small class="text-muted"> / mês</small>
            </h4>
          </div>

          <div
            v-if="plan.cycle_type === 'annually'"
            class="mb-3">
            <div class="text-success">
              Economia de {{ $n(savings, {style: 'currency', currency: 'BRL'}) }} ao ano
            </div>
            <div class="mb-3"><i>* Pagamento anual de <b>{{ $n(price, {style: 'currency', currency: 'BRL'}) }}</b></i></div>
          </div>

          <div
            v-if="planscope.first_invoice_discount"
            class="text-success">
            {{ $n(planscope.first_invoice_discount, {style: 'currency', currency: 'BRL'}) }} de desconto na primeira mensalidade</div>
        </div>

        <h4 v-if="!price">
          Personalizado
        </h4>
      </div>
      <!--<div
        v-if="planscope.description"
        class="mb-4">
        {{ planscope.description }}
      </div>-->

      <div
        v-if="planscope.plan_expiret_at"
        class="alert alert-warning">
        Expira {{ planscope.plan_expiret_at | moment('fromNow', $i18n.locale) }}
      </div>

      <button
        style="cursor: default"
        type="button"
        class="btn btn-lg btn-block btn-outline-info"
        v-if="isCurrent">Atual</button>
      <button
        type="button"
        class="btn btn-lg btn-block btn-primary"
        v-if="!isCurrent && price"
        @click="selected">Contratar</button>
      <button
        type="button"
        class="btn btn-lg btn-block btn-outline-primary"
        v-if="!price">Consulte-nos</button>
    </div>
  </div>

</template>

<script>
export default {
  name: 'BillingPlansBox',
  props: {
    planscope: {
      type: Object
    },
    cycleType: {
      type: String
    },
    isSteps: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    billingResume () {
      return this.$store.getters.getBillingResume
    },
    suspended () {
      return this.billingResume.has_subscription ? this.billingResume.subscription.suspended : false
    },
    plan () {
      return this.planscope.plans.find(item => item.cycle_type === this.cycleType)
    },
    planId () {
      return this.plan ? this.plan._id : null
    },
    discount () {
      return this.plan ? this.plan.discount : null
    },
    price () {
      return this.plan ? this.plan.value : null
    },
    savings () {
      return this.plan ? this.plan.savings : null
    },
    monthPrice () {
      return this.plan ? this.plan.month_value : null
    },
    monthPriceFrom () {
      return this.discount ? this.plan.month_value_from : null
    },
    isCurrent () {
      return this.plan ? this.plan.is_current : null
    },
    cycleName () {
      return this.plan ? { monthly: 'Mensal', annually: 'Anual' }[this.plan.cycle_type] : null
    },
    cycleTypeName () {
      return this.plan ? { monthly: 'mês', annually: 'ano' }[this.plan.cycle_type] : null
    }
  },
  created () {
  },
  methods: {
    selected () {
      this.$store.dispatch('setBillingPlan', {
        plan_id: this.planId,
        name: this.planscope.name,
        billing_mode: this.planscope.billing_mode,
        payable_with: this.planscope.payable_with,
        cycle_type: this.cycleType,
        price: this.price,
        first_invoice_discount: this.planscope.first_invoice_discount
      })
      this.$router.push('/billing/steps/details')
    }
    // reactivate () {
    //   this.loading = true
    //   this.$store.dispatch('billingSubscriptionActivate').then(() => {
    //     this.$router.push('/billing')
    //   })
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Billing/BillingPlansBox.vue